import {
	CLEAR_PRICES_AND_COSTS,
	SET_PRICES_AND_COSTS_APPLY,
	SET_PRICES_AND_COSTS_APPLY_SUCCESS,
	SET_PRICES_AND_COSTS_CALCULATE,
	SET_PRICES_AND_COSTS_CALCULATE_SUCCESS,
	SET_PRICES_AND_COSTS_CONFIRM,
	SET_PRICES_AND_COSTS_CONFIRM_SUCCESS,
	SET_PRICES_AND_COSTS_NEW_VALUE,
	SET_PRICES_AND_COSTS_NEW_VALUE_SUCCESS,
	SET_PRICES_AND_COSTS_PAGINATE,
	SET_PRICES_AND_COSTS_PAGINATE_SUCCESS,
	VERIFY_PRICES_AND_COSTS,
	VERIFY_PRICES_AND_COSTS_SUCCESS
} from 'constants/ActionsTypes'
import {
	IPricesAndCostsApply,
	IPricesAndCostsApplyRes,
	IPricesAndCostsCalculate,
	IPricesAndCostsCalculateRes,
	IPricesAndCostsConfirm,
	IPricesAndCostsConfirmRes,
	IPricesAndCostsNewValue,
	IPricesAndCostsNewValueRes,
	IPricesAndCostsPaginate,
	IPricesAndCostsPaginateRes
} from 'models/PricesAndCostsMassiveUploadInterface'

export const pricesAndCostsApply = (payload: IPricesAndCostsApply) => {
	return {
		type: SET_PRICES_AND_COSTS_APPLY,
		payload
	}
}
export const pricesAndCostsApplySuccess = (
	payload: IPricesAndCostsApplyRes
) => {
	return {
		type: SET_PRICES_AND_COSTS_APPLY_SUCCESS,
		payload
	}
}
export const pricesAndCostsClean = () => ({
	type: CLEAR_PRICES_AND_COSTS
})
export const pricesAndCostsCalculate = (payload: IPricesAndCostsCalculate) => {
	return {
		type: SET_PRICES_AND_COSTS_CALCULATE,
		payload
	}
}
export const pricesAndCostsCalculateSuccess = (
	payload: IPricesAndCostsCalculateRes
) => {
	return {
		type: SET_PRICES_AND_COSTS_CALCULATE_SUCCESS,
		payload
	}
}
export const pricesAndCostsConfirm = (payload: IPricesAndCostsConfirm) => {
	return {
		type: SET_PRICES_AND_COSTS_CONFIRM,
		payload
	}
}
export const pricesAndCostsConfirmSuccess = (
	payload: IPricesAndCostsConfirmRes
) => {
	return {
		type: SET_PRICES_AND_COSTS_CONFIRM_SUCCESS,
		payload
	}
}
export const pricesAndCostsPaginate = (payload: IPricesAndCostsPaginate) => {
	return {
		type: SET_PRICES_AND_COSTS_PAGINATE,
		payload
	}
}
export const pricesAndCostsPaginateSuccess = (
	payload: IPricesAndCostsPaginateRes
) => {
	return {
		type: SET_PRICES_AND_COSTS_PAGINATE_SUCCESS,
		payload
	}
}
export const pricesAndCostsNewValue = (payload: IPricesAndCostsNewValue) => {
	return {
		type: SET_PRICES_AND_COSTS_NEW_VALUE,
		payload
	}
}
export const pricesAndCostsNewValueSuccess = (
	payload: IPricesAndCostsNewValueRes
) => {
	return {
		type: SET_PRICES_AND_COSTS_NEW_VALUE_SUCCESS,
		payload
	}
}
export const pricesAndCostsVerify = (payload: any) => {
	return {
		type: VERIFY_PRICES_AND_COSTS,
		payload
	}
}
export const pricesAndCostsVerifySuccess = (payload: any) => {
	return {
		type: VERIFY_PRICES_AND_COSTS_SUCCESS,
		payload
	}
}
